import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faCopy, faCheck, faLocationDot, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { faLinkedinIn, faGithub } from '@fortawesome/free-brands-svg-icons';

export default function Contact() {
  const [copied, setCopied] = useState(false);
  const email = "syam.rs01@gmail.com";

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <section id="contact" className="py-16 md:py-24 text-white border-t border-zinc-800/80">
      <div className="max-w-4xl mx-auto text-center">
        {/* Pill */}
        <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full text-xs font-semibold bg-teal-500/10 text-teal-300 border border-teal-500/30 uppercase tracking-wider mb-4">
          Get In Touch
        </div>

        {/* Heading */}
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-white mb-4">
          Let's Build Something Resilient Together
        </h2>
        <p className="text-base sm:text-lg text-gray-400 max-w-2xl mx-auto mb-10 leading-relaxed">
          Open to Staff Platform Engineering roles, Cloud Architecture advisory, and consulting engagements across multi-cloud infrastructure, GitOps, and SRE.
        </p>

        {/* Primary Email CTA Box */}
        <div className="p-8 sm:p-10 rounded-3xl bg-gradient-to-b from-dark-200/80 to-dark-300/80 border border-zinc-700/80 backdrop-blur-md shadow-2xl relative overflow-hidden mb-10">
          <div className="absolute top-0 right-0 w-64 h-64 bg-teal-500/10 rounded-full blur-3xl pointer-events-none"></div>

          <div className="relative z-10 flex flex-col items-center gap-5">
            <div className="w-16 h-16 rounded-2xl bg-teal-500/10 border border-teal-500/30 flex items-center justify-center text-teal-400 text-2xl shadow-inner">
              <FontAwesomeIcon icon={faEnvelope} />
            </div>

            <div>
              <span className="text-xs uppercase tracking-wider text-gray-400 font-semibold block mb-1">Direct Contact</span>
              <span className="text-xl sm:text-2xl font-bold text-white font-mono tracking-tight">{email}</span>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-3 pt-2">
              <a
                href={`mailto:${email}`}
                className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-400 text-dark-900 font-bold px-6 py-3 rounded-xl shadow-lg shadow-teal-500/20 hover:shadow-teal-500/40 transition-all duration-200 transform hover:-translate-y-0.5 text-sm"
              >
                <FontAwesomeIcon icon={faPaperPlane} className="text-xs" />
                <span>Send Email</span>
              </a>

              <button
                onClick={handleCopyEmail}
                className="inline-flex items-center gap-2 bg-dark-300 hover:bg-dark-100 text-gray-200 font-semibold px-5 py-3 rounded-xl border border-zinc-700 hover:border-zinc-500 transition-all duration-200 text-sm"
              >
                <FontAwesomeIcon icon={copied ? faCheck : faCopy} className={copied ? "text-emerald-400" : "text-gray-400"} />
                <span>{copied ? "Copied to Clipboard!" : "Copy Email Address"}</span>
              </button>
            </div>
          </div>
        </div>

        {/* Channels Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-left">
          <a
            href="https://www.linkedin.com/in/syam-r-s01/"
            target="_blank"
            rel="noreferrer"
            className="p-5 rounded-2xl bg-dark-200/50 border border-zinc-800 hover:border-teal-500/40 transition-all duration-300 hover:-translate-y-1 group flex items-center gap-4"
          >
            <div className="w-12 h-12 rounded-xl bg-dark-300 border border-zinc-700 flex items-center justify-center text-teal-400 text-xl group-hover:scale-110 transition-transform">
              <FontAwesomeIcon icon={faLinkedinIn} />
            </div>
            <div>
              <span className="text-xs font-semibold uppercase tracking-wider text-gray-400 block">LinkedIn</span>
              <span className="text-sm font-bold text-white group-hover:text-teal-300 transition-colors">/in/syam-r-s01</span>
            </div>
          </a>

          <a
            href="https://github.com/syam-rs"
            target="_blank"
            rel="noreferrer"
            className="p-5 rounded-2xl bg-dark-200/50 border border-zinc-800 hover:border-teal-500/40 transition-all duration-300 hover:-translate-y-1 group flex items-center gap-4"
          >
            <div className="w-12 h-12 rounded-xl bg-dark-300 border border-zinc-700 flex items-center justify-center text-teal-400 text-xl group-hover:scale-110 transition-transform">
              <FontAwesomeIcon icon={faGithub} />
            </div>
            <div>
              <span className="text-xs font-semibold uppercase tracking-wider text-gray-400 block">GitHub</span>
              <span className="text-sm font-bold text-white group-hover:text-teal-300 transition-colors">github.com/syam-rs</span>
            </div>
          </a>

          <div className="p-5 rounded-2xl bg-dark-200/50 border border-zinc-800 flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-dark-300 border border-zinc-700 flex items-center justify-center text-teal-400 text-xl">
              <FontAwesomeIcon icon={faLocationDot} />
            </div>
            <div>
              <span className="text-xs font-semibold uppercase tracking-wider text-gray-400 block">Location</span>
              <span className="text-sm font-bold text-white">Kerala, India · Remote</span>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
